import React from "react";
import Reference_Api from "./Reference_Api";

// const Slide = () => {

const Slide = ({
  id,
  image,
  name,
  designation,
  company,
  address,
  desc,
  valueIndex,
  index,
}) => {
  let position = "nextSlide";
  if (valueIndex === index) {
    position = "activeSlide";
  }
  if (
    valueIndex === index - 1 ||
    (index === 0 && valueIndex === Reference_Api.length - 1)
  ) {
    position = "lastSlide";
  }

  return (
    <>
      <article className={`d_flex ${position}`} key={id}>
        {/*<div className='box d_flex' className={position} key={id}>*/}
        <div className="left box_shodow">
          <div className="img">
            <img src={image} alt={name} />
          </div>
        </div>

        <div className="right ">
          <div className="icon">
            <div className="quote">
              <i className="fa fa-quote-right"></i>
            </div>
          </div>

          <div className="content box_shodow">
            <h1>{name}</h1>
            <h3>{designation}</h3>
            <h3>{company}</h3>
            <h3>{address}</h3>
            <p>{desc}</p>
          </div>
        </div>
      </article>
    </>
  );
};

export default Slide;
